import { Component } from '@verndale/core';

import FieldValidator from './field-validator';

class FormValidator extends Component {
  setupDefaults() {
    this.dom = {
      $fields: this.el._$$('.field'),
      $dropdowns: this.el._$$('.dropdown')
    };

    this.fieldValidators = this.dom.$fields.map(
      (field) => new FieldValidator(field)
    );
  }

  validate(showErrors = true) {
    const errors = this.fieldValidators.filter(
      (fieldValidator) => !fieldValidator.validate(showErrors)
    );

    if (errors.length) {
      if (showErrors) {
        errors[0].dom.$input.focus();
      }

      return false;
    }

    return true;
  }

  reset() {
    const { $dropdowns } = this.dom;
    this.fieldValidators.forEach((fieldValidator) => fieldValidator.reset());

    if ($dropdowns && $dropdowns.length) {
      $dropdowns.forEach(($dropdown) => {
        const $button = $dropdown._$('.dropdown__button');

        $button.textContent = $button.dataset.defaultLabel;
      });
    }
  }
}

export default FormValidator;
